import { render, staticRenderFns } from "./FirmAdvisors.vue?vue&type=template&id=6b191cbf&scoped=true&"
import script from "./FirmAdvisors.vue?vue&type=script&setup=true&lang=js&"
export * from "./FirmAdvisors.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./FirmAdvisors.vue?vue&type=style&index=0&id=6b191cbf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b191cbf",
  null
  
)

export default component.exports